import mountTariffOverviewContainer from 'Container/App';
import './style.scss';

// The following line hopefully disables back/forward cache (BFCache) in Firefox.
// so that the DDP can not be reached with a cached back/forwards navigation.
// @see https://developer.mozilla.org/en-US/docs/Glossary/bfcache
// @see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
// If the app was perfect it should work with BFCache, but in addition to not being perfect
// Firefox has a bug so the SessionStorage is not synced between BF-cached pages.
// @see https://confluence.wf-de.vodafone.com/pages/viewpage.action?pageId=302394411
window.addEventListener('unload', () => {});

mountTariffOverviewContainer();
